import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { lastEmail } from "../lib/session";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState(new URLSearchParams(window.location.search).get("email") || lastEmail() || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setSent(data.message); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="forgot-password-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-2xl p-8 space-y-5 shadow-sm">
        <span className="h-11 w-11 rounded-xl bg-sky-50 text-sky-700 flex items-center justify-center"><Mail className="h-5 w-5" /></span>
        <div><h1 className="font-display text-2xl font-semibold">Esqueci minha senha</h1>
          <p className="text-sm text-slate-500 mt-1">Informe seu e-mail de acesso. Enviaremos um link para você criar uma nova senha.</p></div>
        {sent ? <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="forgot-password-sent">{sent} Confira também a caixa de spam. O link vale por 1 hora.</div> : <>
          <div><Label htmlFor="fp-email">E-mail</Label><Input id="fp-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" required data-testid="forgot-password-email" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 font-bold" data-testid="forgot-password-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "ENVIAR LINK"}</Button></>}
        <Link to="/login" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 transition-colors" data-testid="forgot-password-back"><ArrowLeft className="h-4 w-4" />Voltar para o login</Link>
      </form>
    </div>);
}
